var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import TabsMUI from "@mui/material/Tabs";
import TabMUI from "@mui/material/Tab";
export const Tabs = (_a) => {
    var { tabs, extra } = _a, props = __rest(_a, ["tabs", "extra"]);
    return (_jsxs("div", { style: { position: 'relative' }, children: [_jsx(TabsMUI, Object.assign({ variant: "scrollable", scrollButtons: false, allowScrollButtonsMobile: true }, props, { children: tabs.map((tab, i) => (_createElement(TabMUI, Object.assign({ "data-testid": "tab" }, tab, { key: i })))) })), extra && (_jsx("div", { "data-testid": "extra", style: { position: 'absolute', right: 0, top: 6 }, children: extra }))] }));
};
export default Tabs;
